import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { BillingAddress } from '../../models/billing-address.model';

const HTTP_BAD_REQUEST = 400;
const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;

const POSITIVE_INTEGER_ID = /^[1-9]\d*$/;

/** Id de ruta (customerId/cardId) válido: entero positivo en texto, apto para interpolar en URLs de API. */
export function isPositiveIntegerId(value: string | null | undefined): value is string {
  return typeof value === 'string' && POSITIVE_INTEGER_ID.test(value);
}

/** La dirección devuelta por el backend debe traer un id numérico finito y positivo. */
export function hasValidAddressId(address: BillingAddress | null | undefined): address is BillingAddress {
  const id = address?.id;
  return typeof id === 'number' && Number.isFinite(id) && id > 0;
}

/** Mensaje de error para las operaciones de dirección de facturación (400 usa el mensaje del backend). */
export function billingAddressErrorMessage(error: unknown, translate: TranslateService): string {
  const status = error instanceof HttpErrorResponse ? error.status : null;
  if (status === HTTP_BAD_REQUEST) {
    const backendMessage = (error as HttpErrorResponse).error?.message;
    return typeof backendMessage === 'string' && backendMessage.trim()
      ? backendMessage
      : translate.instant('customerCards.errorGeneric');
  }
  if (status === HTTP_NOT_FOUND) {
    return translate.instant('customerCards.addressNotFound');
  }
  if (status === HTTP_FORBIDDEN) {
    return translate.instant('customerCards.noPermission');
  }
  return translate.instant('customerCards.errorGeneric');
}
